import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoAltroDocumentoStep2Component } from './conservazione-carica-documento-altro-documento-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-altro-documento-step2', {
            url: '/conservazione-carica-altri-documenti',
            ncyBreadcrumb: {
                label: 'Carica Altri Documenti',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-altro-documento-step2 flex="100"></conservazione-carica-documento-altro-documento-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoAltroDocumentoStep2Module: string = ng
    .module('conservazione-carica-documento-altro-documento-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoAltroDocumentoStep2', ConservazioneCaricaDocumentoAltroDocumentoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-altro-documento-step2/conservazione-carica-documento-altro-documento-step2.module.ts